import { render } from "./Bonus.vue?vue&type=template&id=4c37defe"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Bonus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c37defe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c37defe', __exports__)) {
    api.reload('4c37defe', __exports__)
  }
  
  module.hot.accept("./Bonus.vue?vue&type=template&id=4c37defe", () => {
    api.rerender('4c37defe', render)
  })

}


export default __exports__